import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomRight32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowFitBottomRight32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.657 6a1 1 0 0 0-1-1H5v10.657h1-1a1 1 0 1 0 2 0H6h1V8.414l16.52 16.52a2 2 0 0 1-.516.068h-11.5a1 1 0 1 0 0 2h11.5a4 4 0 0 0 4-4v-11.5a1 1 0 1 0-2 0v11.5q0 .27-.069.519L8.413 7h7.244a1 1 0 0 0 1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomRight32);
